"use client";

import {
  Toaster as ChakraToaster,
  Portal,
  Spinner,
  Stack,
  Toast,
  createToaster,
} from "@chakra-ui/react";

// Global toaster instance. Import `toaster` anywhere and call
// toaster.create({ type, title, description }) to show a toast.
// Placement is top-right: always visible in a corner regardless of screen
// size (the old bottom-center toast got lost on large screens), and clear
// of the centered header logo. Change `placement` to "top" for top-center.
export const toaster = createToaster({
  placement: "top-end",
  pauseOnPageIdle: true,
});

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: "4" }}>
        {(toast) => (
          <Toast.Root
            width={{ md: "sm" }}
            boxShadow="0px 6px 16px rgba(0,0,0,0.16)"
            // The default recipe's enter keyframes don't run in this app's
            // Chakra system, leaving the toast stuck at opacity:0 /
            // translate:-100%. Drive visibility off the data-state attr
            // directly with a transition so it fades/slides in reliably.
            css={{
              transition: "opacity 0.2s ease, translate 0.2s ease",
              "&[data-state=open]": { opacity: 1, translate: "0 0" },
              "&[data-state=closed]": { opacity: 0, translate: "0 -8px" },
            }}
          >
            {toast.type === "loading" ? (
              <Spinner size="sm" color="blue.solid" />
            ) : (
              <Toast.Indicator />
            )}
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && (
                <Toast.Description>{toast.description}</Toast.Description>
              )}
            </Stack>
            {toast.action && (
              <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
            )}
            <Toast.CloseTrigger />
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
};
